/* eslint-disable sonarjs/no-duplicate-string */
import React, { Component } from 'react';
import { PLAYERS_ID } from '../../../../constants';
import TennisTieBreakHistoryRow from './TennisTieBreakHistoryRow';

class TennisMatchTieBreakRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tbSectionOpen: false,
    };
  }

  toggleTBSection = () => {
    this.setState({
      tbSectionOpen: !this.state.tbSectionOpen,
    });
  };

  render() {
    return (
      <div
        id="tiebreak"
        className={`tennisDetails ${this.state.tbSectionOpen ? 'tennisDetails--dropdownOpen' : ''}`}
      >

        <div className="tennisDetails__info">
          <div className="tennisDetails__info-serve text-right" />
          <div className="tennisDetails__info-icon" />
          <div className="tennisDetails__info-score">
            <span className={`${this.props.gameHistory?.winningPlayer === PLAYERS_ID.PLAYER_1 ? 'clr-primary' : ''}`}>
              {this.props.gameHistory.playerOneGamesScore}
              <sup>{this.props.gameHistory?.playerOneTieBreakScore}</sup>
            </span>
            {' '}
            <span>-</span>
            {' '}
            <span className={`${this.props.gameHistory?.winningPlayer === PLAYERS_ID.PLAYER_2 ? 'clr-primary' : ''}`}>
              {this.props.gameHistory.playerTwoGamesScore}
              <sup>{this.props.gameHistory?.playerTwoTieBreakScore}</sup>
            </span>
          </div>
          <div className="tennisDetails__info-icon" />
          <div className="tennisDetails__info-serve text-right">
            <div
              className="tennisDetails__dropdownBtn"
              onClick={this.toggleTBSection}
            >
              <i className="icon-dropdown" />
            </div>
          </div>
        </div>

        <div className="tennisDetails__tieBreak">
          {this.props.gameHistory
        && this.props.gameHistory.tieBreakHistory
        && this.props.gameHistory.tieBreakHistory.map((history) => (
          <TennisTieBreakHistoryRow
            key={`tieBreak-${history?.playerOneScore}-${history?.playerTwoScore}`}
            history={history}
            hasWinningPlayer={this.props.hasWinningPlayer}
          />
        ))}
        </div>
      </div>
    );
  }
}

export default TennisMatchTieBreakRow;
